const ACTUAL_SEK_AMOUNT_NOT_POSITIVE_MESSAGE = "Enter an amount greater than 0.";

export interface ParsedActualSekAmount {
  /** The amount to submit, or null when the input cannot be submitted. */
  amount: number | null;
  /** Shown under the field; null while the field is empty or valid. */
  error: string | null;
}

/**
 * FIN-1042: the SEK amount a consultant types for an external settlement is always positive —
 * no document type stores a negative amount (learnings/037). The backend refuses it too
 * (INVALID_SETTLEMENT_AMOUNT); this keeps the refusal visible before anything is sent.
 */
export function parseActualSekAmount(input: string): ParsedActualSekAmount {
  if (input.trim() === "") return { amount: null, error: null };
  const parsed = Number(input);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return { amount: null, error: ACTUAL_SEK_AMOUNT_NOT_POSITIVE_MESSAGE };
  }
  return { amount: parsed, error: null };
}
